import React, { useState, useEffect, useContext, useRef } from "react";
import { AppContext } from "../../AppContextProvider";
import { useTranslation } from "react-i18next";
import CircleProgressComponent from "./CircleProgressComponent";
//import "react-circular-progressbar/dist/styles.css";

export default function MenuComponent(props) {
  const { t } = useTranslation();
  const context = useContext(AppContext);
  const basicRef = useRef(null);
  const [isDark, setIsDark] = useState(true);

  const categoriesMap = props.originalNodes
    .filter((k) => k.level === 1)
    .filter((k) => k.label !== "User Files")
    .map((k) => {
      return { filter: k.label, category: k.label };
    });

  const fullProcess = 10000;
  const getProcessForCid = (cid) => {
    const node = props.originalNodes.find((k) => k.cid === cid);
    if (!node || !node.childrenCount) return 1;
    return parseInt(Math.max((node.childrenCount * 100) / fullProcess, 1));
  };
  const process1 = getProcessForCid(1);
  const process2 = getProcessForCid(2);
  const process3 = getProcessForCid(3);
  const process4 = getProcessForCid(4);
  const process5 = getProcessForCid(5);
  const process6 = getProcessForCid(6);
  const process7 = getProcessForCid(7);
  const process8 = getProcessForCid(8);

  const everythingProcess = (process1 + process2 + process3 + process4 + process5 + process6 + process7 + process8) / 8;

  useEffect(() => {
    if (
      document.documentElement.getAttribute("data-color-mode") === "dark" ||
      document.documentElement.getAttribute("data-color-mode") === null
    ) {
      setIsDark(true);
    } else {
      setIsDark(false);
    }
  }, [context.getState()?.isRender]);

  return (
    <div className="menu-component-div">
      <div
        className={props.activeTab === "everything" ? "category-everything active" : "category-everything"}
        onClick={() => {
          if (props.isVisibility2) {
            props.handleWindowInfoSizeChange();
            props.setActiveTab("everything");
            sessionStorage.setItem("activeTab", JSON.stringify("everything"));
            props.setBubbleFilter(0, "everything");
            props.setCategory("everything");
          }
        }}
      >
        <CircleProgressComponent
          percentage={everythingProcess}
          primaryColor={isDark ? ["#a2e1ee", "#114954"] : ["#b3e7f1", "#145865"]}
          height={"35px"}
          width={"35px"}
          widthNumber={35}
          strokeWidth={5}
        />
        <span className="category-name">Everything</span>
      </div>
      {categoriesMap.length > 0 && (
        <div
          className={props.activeTab === categoriesMap[0].filter ? "category-0 active" : "category-0"}
          onClick={() => {
            if (props.isVisibility2) {
              props.handleWindowInfoSizeChange();
              props.setActiveTab(categoriesMap[0].filter);
              sessionStorage.setItem("activeTab", JSON.stringify(categoriesMap[0].filter));
              props.setBubbleFilter(1, categoriesMap[0].category);
              props.setCategory(categoriesMap[0].filter);
            }
          }}
        >
          <CircleProgressComponent
            percentage={Math.min(process1, 100)}
            primaryColor={isDark ? ["#ffb8e0", "#3c002b"] : ["#ffe5f4", "#770059"]}
            height={"35px"}
            width={"35px"}
            widthNumber={35}
            strokeWidth={5}
          />
          <span className="category-name">{categoriesMap[0].category}</span>
        </div>
      )}

      {categoriesMap.length > 1 && (
        <div
          className={props.activeTab === categoriesMap[1].filter ? "category-1 active" : "category-1"}
          onClick={() => {
            if (props.isVisibility2) {
              props.handleWindowInfoSizeChange();
              props.setActiveTab(categoriesMap[1].filter);
              sessionStorage.setItem("activeTab", JSON.stringify(categoriesMap[1].filter));
              props.setBubbleFilter(2, categoriesMap[1].category);
              props.setCategory(categoriesMap[1].filter);
            }
          }}
        >
          <CircleProgressComponent
            percentage={Math.min(process2, 100)}
            primaryColor={isDark ? ["#ffb693", "#351000"] : ["#ffe7db", "#6a2800"]}
            height={"35px"}
            width={"35px"}
            widthNumber={35}
            strokeWidth={5}
          />
          <span className="category-name">{categoriesMap[1].category}</span>
        </div>
      )}

      {categoriesMap.length > 2 && (
        <div
          className={props.activeTab === categoriesMap[2].filter ? "category-2 active" : "category-2"}
          onClick={() => {
            if (props.isVisibility2) {
              props.handleWindowInfoSizeChange();
              props.setActiveTab(categoriesMap[2].filter);
              sessionStorage.setItem("activeTab", JSON.stringify(categoriesMap[2].filter));
              props.setBubbleFilter(3, categoriesMap[2].filter);
              props.setCategory(categoriesMap[2].filter);
            }
          }}
        >
          <CircleProgressComponent
            percentage={Math.min(process3, 100)}
            primaryColor={isDark ? ["#b7f732", "#131f00"] : ["#e1fea5", "#324800"]}
            height={"35px"}
            width={"35px"}
            widthNumber={35}
            strokeWidth={5}
          />
          <span className="category-name">{categoriesMap[2].category}</span>
        </div>
      )}

      {categoriesMap.length > 3 && (
        <div
          className={props.activeTab === categoriesMap[3].filter ? "category-3 active" : "category-3"}
          onClick={() => {
            if (props.isVisibility2) {
              props.handleWindowInfoSizeChange();
              props.setActiveTab(categoriesMap[3].filter);
              sessionStorage.setItem("activeTab", JSON.stringify(categoriesMap[3].filter));
              props.setBubbleFilter(4, categoriesMap[3].filter);
              props.setCategory(categoriesMap[3].filter);
            }
          }}
        >
          <CircleProgressComponent
            percentage={Math.min(process4, 100)}
            primaryColor={isDark ? ["#77f875", "#002103"] : ["#cdffcc", "#004d0c"]}
            height={"35px"}
            width={"35px"}
            widthNumber={35}
            strokeWidth={5}
          />
          <span className="category-name">{categoriesMap[3].category}</span>
        </div>
      )}

      {categoriesMap.length > 4 && (
        <div
          className={props.activeTab === categoriesMap[4].filter ? "category-4 active" : "category-4"}
          onClick={() => {
            if (props.isVisibility2) {
              props.handleWindowInfoSizeChange();
              props.setActiveTab(categoriesMap[4].filter);
              sessionStorage.setItem("activeTab", JSON.stringify(categoriesMap[4].filter));
              props.setBubbleFilter(5, categoriesMap[4].filter);
              props.setCategory(categoriesMap[4].filter);
            }
          }}
        >
          <CircleProgressComponent
            percentage={Math.min(process5, 100)}
            primaryColor={isDark ? ["#3affb2", "#002012"] : ["#c7ffe9", "#004b30"]}
            height={"35px"}
            width={"35px"}
            widthNumber={35}
            strokeWidth={5}
          />
          <span className="category-name">{categoriesMap[4].category}</span>
        </div>
      )}

      {categoriesMap.length > 5 && (
        <div
          className={props.activeTab === categoriesMap[5].filter ? "category-5 active" : "category-5"}
          onClick={() => {
            if (props.isVisibility2) {
              props.handleWindowInfoSizeChange();
              props.setActiveTab(categoriesMap[5].filter);
              sessionStorage.setItem("activeTab", JSON.stringify(categoriesMap[5].filter));
              props.setBubbleFilter(6, categoriesMap[5].filter);
              props.setCategory(categoriesMap[5].filter);
            }
          }}
        >
          <CircleProgressComponent
            percentage={Math.min(process6, 100)}
            primaryColor={isDark ? ["#71d1ff", "#001d2e"] : ["#cceeff", "#00405d"]}
            height={"35px"}
            width={"35px"}
            widthNumber={35}
            strokeWidth={5}
          />
          <span className="category-name">{categoriesMap[5].category}</span>
        </div>
      )}

      {categoriesMap.length > 6 && (
        <div
          className={props.activeTab === categoriesMap[6].filter ? "category-6 active" : "category-6"}
          onClick={() => {
            if (props.isVisibility2) {
              props.handleWindowInfoSizeChange();
              props.setActiveTab(categoriesMap[6].filter);
              sessionStorage.setItem("activeTab", JSON.stringify(categoriesMap[6].filter));
              props.setBubbleFilter(7, categoriesMap[6].filter);
              props.setCategory(categoriesMap[6].filter);
            }
          }}
        >
          <CircleProgressComponent
            percentage={Math.min(process7, 100)}
            primaryColor={isDark ? ["#bdbdff", "#130a66"] : ["#e5e5ff", "#2118a5"]}
            height={"35px"}
            width={"35px"}
            widthNumber={35}
            strokeWidth={5}
          />
          <span className="category-name">{categoriesMap[6].category}</span>
        </div>
      )}

      {categoriesMap.length > 7 && (
        <div
          className={props.activeTab === categoriesMap[7].filter ? "category-7 active" : "category-7"}
          onClick={() => {
            if (props.isVisibility2) {
              props.handleWindowInfoSizeChange();
              props.setActiveTab(categoriesMap[7].filter);
              sessionStorage.setItem("activeTab", JSON.stringify(categoriesMap[7].filter));
              props.setBubbleFilter(8, categoriesMap[7].filter);
              props.setCategory(categoriesMap[7].filter);
            }
          }}
        >
          <CircleProgressComponent
            percentage={Math.min(process8, 100)}
            primaryColor={isDark ? ["#e9b8ff", "#310049"] : ["#f7e5ff", "#63008e"]}
            height={"35px"}
            width={"35px"}
            widthNumber={35}
            strokeWidth={5}
          />
          <span className="category-name">{categoriesMap[7].category}</span>
        </div>
      )}
    </div>
  );
}
